// Central media configuration - consolidated demos + media assets
export const MEDIA = {
  HERO_HOME: {
    src: "https://i.ibb.co/0jGKJfht/Chat-GPT-Image-Jan-19-2026-01-04-57-PM.png",
    alt: "Custom hero background image for trade landing page",
    title: "Custom hero background image for trade landing page",
    caption: "Professional pages that convert visitors into customers"
  },
  HERO_HOME_MOBILE: {
    src: "https://i.ibb.co/tw9NP735/Chat-GPT-Image-Jan-19-2026-02-30-34-PM.png",
    alt: "Premium trade landing page hero image (mobile)",
    title: "Premium trade landing page hero image (mobile)",
    caption: "Professional landing pages for Australian trades"
  },
  // Demo Specific Assets
  DEMO_ELECTRICIAN: {
    src: "https://i.ibb.co/Wpf7XZv3/e-LECTTRICIAN-6.png",
    alt: "Electrician landing page preview on mobile",
    title: "Electrician - Western Sydney NSW",
    caption: "Built using BPA Trade Pages framework"
  },
  DEMO_DETAILING: {
    src: "https://i.ibb.co/DgL9T0BM/Chat-GPT-Image-Jan-17-2026-09-33-44-PM.png",
    alt: "Mobile detailing landing page preview on phone",
    title: "Mobile Detailing – Northern Beaches NSW",
    caption: "Built using BPA Trade Pages framework"
  },
  DEMO_LANDSCAPING: {
    src: "https://i.ibb.co/5xBb6hSv/Blog-image-Multi-Level-Garden-Design.jpg",
    alt: "Landscaping business landing page preview",
    title: "Landscaping – Greater Sydney NSW",
    caption: "Built using BPA Trade Pages framework"
  },
  DEMO_ROOFING: {
    src: "https://i.ibb.co/LdhgwhCS/Power-Wash-Pro-16.png",
    alt: "Roofing business landing page preview",
    title: "Roofing - WA",
    caption: "Built using BPA Trade Pages framework"
  },
  DEMO_PRESSURE_WASH: {
    src: "https://i.ibb.co/wrF0Mky3/Power-Wash-Pro-7.png",
    alt: "Pressure Wash business landing page preview",
    title: "Pressure Wash - Coastal Melbourne",
    caption: "Built using BPA Trade Pages framework"
  },
  DEMO_CLEANING: {
    src: "https://i.ibb.co/mphPBtv/Coastal-Cleanin-Co-3.png",
    alt: "Cleaning business landing page preview",
    title: "Cleaning Company - QLD",
    caption: "Built using BPA Trade Pages framework"
  },
  // Legacy Samples
  SAMPLE_1: {
    src: "https://images.unsplash.com/photo-1621905251189-08b45d6a269e?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    alt: "Sample Electrician Landing Page",
    title: "Electrical Service Mockup",
    caption: "Built using BPA Trade Pages framework"
  },
  SAMPLE_2: {
    src: "https://images.unsplash.com/photo-1584622650111-993a426fbf0a?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    alt: "Sample Plumber Landing Page",
    title: "Plumbing Service Mockup",
    caption: "Built using BPA Trade Pages framework"
  },
  SAMPLE_3: {
    src: "https://images.unsplash.com/photo-1558905619-17154944b251?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    alt: "Sample Landscaper Landing Page",
    title: "Landscaping Service Mockup",
    caption: "Built using BPA Trade Pages framework"
  },
  MOCKUP_DETAILING: {
    src: "https://images.unsplash.com/photo-1601362840469-51e4d8d59085?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    alt: "Premium mobile detailing landing page mockup",
    title: "Mobile Detailing Layout",
    caption: "Built using BPA Trade Pages framework"
  },
  MOCKUP_ROOFING: {
    src: "https://images.unsplash.com/photo-1632759162353-194941ee24fd?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    alt: "Professional roofing services landing page mockup",
    title: "Roofing Service Layout",
    caption: "Built using BPA Trade Pages framework"
  },
  MOCKUP_FENCING: {
    src: "https://images.unsplash.com/photo-1504307651254-35680f3361d4?ixlib=rb-4.0.3&auto=format&fit=crop&w=800&q=80",
    alt: "High-quality fencing business landing page mockup",
    title: "Fencing Business Layout",
    caption: "Built using BPA Trade Pages framework"
  }
};

// Fallback demo configuration (used when CMS is unavailable)
export const FALLBACK_DEMOS = [
  { id: "electrician", imageUrl: MEDIA.DEMO_ELECTRICIAN.src, label: "Electrician – Western Sydney NSW", url: "https://astonishing-longma-c71bb1.netlify.app" },
  { id: "detailing", imageUrl: MEDIA.DEMO_DETAILING.src, label: "Mobile Detailing – Northern Beaches NSW", url: "https://shimmering-maamoul-b09d7e.netlify.app" },
  { id: "landscaping", imageUrl: MEDIA.DEMO_LANDSCAPING.src, label: "JD's Mowing", url: "https://eclectic-entremet-5fd078.netlify.app" },
  { id: "roofing", imageUrl: MEDIA.DEMO_ROOFING.src, label: "Roofing - Western Australia", url: "https://cozy-palmier-6f1d3a.netlify.app" },
  { id: "pressure-wash", imageUrl: MEDIA.DEMO_PRESSURE_WASH.src, label: "POWERWASH PRO - COASTAL MELBOURNE", url: "https://reliable-rolypoly-98bfc6.netlify.app" },
  { id: "cleaning", imageUrl: MEDIA.DEMO_CLEANING.src, label: "COASTLINE CLEANING Co- QLD", url: "https://dreamy-marshmallow-f31116.netlify.app" }
];

// Image fallback mapping by preview ID variations
const IMAGE_MAP = {
  'electrician': MEDIA.DEMO_ELECTRICIAN.src,
  'detailing': MEDIA.DEMO_DETAILING.src,
  'mobile-detailing': MEDIA.DEMO_DETAILING.src,
  'mobile-detail': MEDIA.DEMO_DETAILING.src,
  'landscaping': MEDIA.DEMO_LANDSCAPING.src,
  'mowing': MEDIA.DEMO_LANDSCAPING.src,
  'jd-mowing': MEDIA.DEMO_LANDSCAPING.src,
  'roofing': MEDIA.DEMO_ROOFING.src,
  'pressure-wash': MEDIA.DEMO_PRESSURE_WASH.src,
  'pressurewash': MEDIA.DEMO_PRESSURE_WASH.src,
  'powerwash': MEDIA.DEMO_PRESSURE_WASH.src,
  'power-wash': MEDIA.DEMO_PRESSURE_WASH.src,
  'cleaning': MEDIA.DEMO_CLEANING.src,
  'clean': MEDIA.DEMO_CLEANING.src
};

// Get image by normalized preview ID
export const getImageByPreviewId = (previewId) => {
  if (!previewId) return null;
  const normalized = previewId
    .toLowerCase()
    .trim()
    .replace(/[\s_]+/g, '-')
    .replace(/-+/g, '-')
    .replace(/^-|-$/g, '');
  return IMAGE_MAP[normalized] || null;
};